import { useContext } from 'react';
import { AuthContext } from '../auth/authContext';

export const getBuyflowLink = (unauthLink: string, authLink: string) => {
  const { user } = useContext(AuthContext);

  if (user) {
    return authLink;
  }

  return unauthLink;
};
